<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="carbonsegments.icon" class="mr-2"></i>
                        <span>{{ carbonsegments.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Snapshot dB" label-for="snapshot" label-cols="12">
                                    <treeselect v-model="snapshot" :clearable="false" :options="options_snapshot"
                                        :disabled="options_snapshot.length == 1" placeholder="Show all..."></treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Type" label-for="type" label-cols="12">
                                    <treeselect v-model="type" :clearable="true" :multiple="true" :options="options_type"
                                        placeholder="Show all..."></treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">

                                <b-form-group label="Start City ( Paste List )" label-for="startcity" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="startcity" v-model="startcity" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste start city (LTN,LGW...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>

                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="startcity = []">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Start City" label-size="sm">
                                    <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                                        v-model="startcity" :multiple="false" :clearable="true" :async="true"
                                        :load-options="treeselect_loadAirport" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">

                                <b-form-group label="End City ( Paste List )" label-for="endcity" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="endcity" v-model="endcity" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste end city (CDG,GRZ...)" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>

                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="endcity = []">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="End City" label-size="sm">
                                    <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                                        v-model="endcity" :multiple="false" :clearable="true" :async="true"
                                        :load-options="treeselect_loadAirport" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">

                                <b-form-group label="Equipment ( Paste List )" label-for="equipment" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="equipment" v-model="equipment" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste equipment (ER3,332...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>

                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="equipment = []">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Equipment" label-size="sm">
                                    <treeselect placeholder="Enter equipment..." searchPromptText="Type at least 3 chars..."
                                        v-model="equipment" :multiple="false" :clearable="true" :async="true"
                                        :load-options="treeselect_loadAircraft" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Cabin" label-for="cabin" label-cols="12">
                                    <treeselect v-model="cabin" :clearable="true" :multiple="true" :options="options_cabin"
                                        placeholder="Show all..."></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Methodology" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="methodology" placeholder="Methodology" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!methodology"
                                                @click="methodology = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Notes" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="notes" placeholder="Notes" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!notes"
                                                @click="notes = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Source" label-for="source" label-cols="12">
                                    <treeselect v-model="source" :clearable="true" :multiple="true"
                                        :options="options_source" placeholder="Show all..."></treeselect>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">

                                <b-form-group label-cols="12" label="Updated At" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="updated_at" v-model="updated_at" :opens="'right'"
                                            :locale-data="{
                                                direction: 'ltr',
                                                format: 'dd/mm/yy HH:MM',
                                                applyLabel: 'Apply It',
                                                cancelLabel: '< Back',
                                                daysOfWeek: [
                                                    'Sun',
                                                    'Mon',
                                                    'Tue',
                                                    'Wed',
                                                    'Thu',
                                                    'Fri',
                                                    'Sat',
                                                ],
                                                monthNames: [
                                                    'January',
                                                    'February',
                                                    'March',
                                                    'April',
                                                    'May',
                                                    'June',
                                                    'July',
                                                    'August',
                                                    'September',
                                                    'October',
                                                    'November',
                                                    'December',
                                                ],
                                                firstDay: 1,
                                            }" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false" :timePicker="true"
                                            :timePicker24Hour="true">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="updated_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Updated By" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="updated_by" placeholder="Updated By" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!updated_by"
                                                @click="updated_by = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Emission" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="emission" placeholder="Emission" trim
                                            list="emission-list-id"> </b-form-input>
                                        <datalist id="emission-list-id">
                                            <option v-for="emission in emissions" :key="emission">
                                                {{ emission }}
                                            </option>
                                        </datalist>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!emission"
                                                @click="emission = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Distance" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="distance" placeholder="Distance" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!distance"
                                                @click="distance = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <div id="carbonsegments" class="px-3 mx-0 text-left">
                    <div v-if="carbonsegments.pastespecial">
                        <b-row class="mt-2" no-gutters>
                            <b-col cols="9">
                                <b-form-group>
                                    <b-form-checkbox-group id="segments_paste_selected"
                                        v-model="carbonsegments.paste_selected" :options="carbonsegments.paste_options"
                                        value-field="id" text-field="label"></b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                         
                            <b-col cols="auto" class="text-right ml-auto">
                                <b-row>
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="carbonsegments_saveit()">
                                            <i class="fa fa-floppy-o"></i>
                                            Save It
                                        </b-link>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="carbonsegments_headers()">
                                            Headers
                                        </b-link>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-link size="sm" variant="outline-primary" @click="carbonsegments_paste_read()">
                                            <i class="fa fa-magic"></i>
                                            Read It
                                        </b-link>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label-cols="12">
                                    <b-form-textarea id="data" v-model="carbonsegments.paste"
                                        placeholder="Paste segment data" rows="6"
                                        class="smalltextarea courier"></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <d-table classdivtable="availtable datatable" refid="carbonsegments" :icon="carbonsegments.icon"
                        :busy="carbonsegments.busy" :toolbarlibrary="carbonsegments.toolbarlibrary"
                        :tools="carbonsegments.tools" :badges="carbonsegments.badges" :fields="carbonsegments.fields"
                        :items="carbonsegments.items" :page="carbonsegments.page" :offset="carbonsegments.offset"
                        :limit="carbonsegments.limit" @load="carbonsegments_load" @click="carbonsegments_click"
                        @changed="carbonsegments_click('save', $event)" @select="carbonsegments_select">
                    </d-table>
                </div>

                <!-- <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="carbonsegments" :icon="carbonsegments.icon"
                        :busy="carbonsegments.busy" :toolbarlibrary="carbonsegments.toolbarlibrary"
                        :tools="carbonsegments.tools" :badges="carbonsegments.badges" :fields="carbonsegments.fields"
                        :items="carbonsegments.items" :page="carbonsegments.page" :offset="carbonsegments.offset"
                        :limit="carbonsegments.limit" @load="carbonsegments_load" @click="carbonsegments_click"
                        @changed="carbonsegments_click('save', $event)" @select="carbonsegments_select">
                    </d-table>
                </div> -->
            </div>

            <!-- @go="carbonsegments_click('go')" -->
            <div v-show="component">
                <component :is="component" :selection="carbonsegments.selected" :snapshot="snapshot" :config="cconfig"
                    @discard="carbonsegments_click('discard')"></component>
            </div>

            <b-row class="px-3">
                <b-col>
                    <b-alert :show="message ? true : false" variant="info">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                <span v-html="message"></span></b-col></b-row>
                    </b-alert></b-col>
            </b-row>
        </b-card>
    </div>
</template>
    
    
<script>
import gql from "graphql-tag";

import CarbonSegmentImport from "./Components/CarbonSegmentImport";
import CarbonSegmentEdit from "./Components/CarbonSegmentEdit";

export default {
    name: "CarbonSegments",
    components: { CarbonSegmentImport, CarbonSegmentEdit },
    watch: {
        async snapshot() {
            await this.carbonsegments_load(0);
        },
        async type() {
            await this.carbonsegments_load(0);
        },
        async startcity() {
            await this.carbonsegments_load(0);
        },
        async endcity() {
            await this.carbonsegments_load(0);
        },
        async equipment() {
            await this.carbonsegments_load(0);
        },
        async methodology() {
            await this.carbonsegments_load(0);
        },
        async cabin() {
            await this.carbonsegments_load(0);
        },
        async source() {
            await this.carbonsegments_load(0);
        },
        async notes() {
            await this.carbonsegments_load(0);
        },
        async updated_by() {
            await this.carbonsegments_load(0);
        },
        async updated_at() {
            await this.carbonsegments_load(0);
        },
        async emission() {
            await this.carbonsegments_load(0);
        },
        async distance() {
            await this.carbonsegments_load(0);
        },
    },
    data() {
        return {
            snapshot: "live_finance",
            type: [],
            cabin: [],
            source: [],
            startcity: [],
            endcity: [],
            equipment: [],
            methodology: null,
            notes: null,
            updated_by: null,
            updated_at: { startDate: null, endDate: null },
            emission: null,
            emissions: ["<api pending>"],
            distance: null,
            options_type: [
                { id: "AIR", label: "Air" },
                { id: "HTL", label: "Hotel" },
                { id: "CAR", label: "Car" },
                { id: "RAI", label: "Rail" },
                { id: "XFR", label: "Transfer" },
                { id: "SEA", label: "Ferry" },
            ],
            options_cabin: [
                { id: "economy", label: "ECONOMY" },
                { id: "premium", label: "PREMIUM" },
                { id: "business", label: "BUSINESS" },
                { id: "first", label: "FIRST" },

            ],
            options_source: [
                { id: "thrust", label: "THRUST" },
                { id: "icao", label: "ICAO" },

            ],
            options_snapshot: [
                { id: "live_finance", label: "live_finance" },
            ],
            carbonsegments: {
                title: "Carbon Segments",
                icon: "fa fa-fire text-orange",
                debounce: 500,
                busy: false,
                denied: [],
                page: 1,
                offset: 0,
                limit: 15,
                edit: false,
                pastespecial: false,
                paste: null,
                paste_selected: ["firstrowheader", "reversenamecap"],
                paste_options: [
                    { id: "firstrowheader", label: "First Row Headers", disabled: true },
                    { id: "secondrowskip", label: "Second Row Skip" },
                    { id: "filldown", label: "Fill Down" },
                ],
                tools: "go,filter,import,export,clipboard,add,edit,pastespecial,deleteconfirm,cancelconfirm,pendingconfirm,publishconfirm",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-ban text-warning",
                        position: "toolbar",
                        action: "cancelconfirm",
                        label: "Cancel Pending",
                        overlay: {
                            message: "Are you sure you want to cancel <api pending> ?",
                            buttons: [
                                {
                                    label: "Yes",
                                    variant: "warning",
                                    action: "cancel",
                                },
                                {
                                    label: "No",
                                    class: "ml-2",
                                },
                            ],
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-share text-warning",
                        position: "toolbar",
                        action: "pendingconfirm",
                        label: "Request Segments",
                        overlay: {
                            message: "Are you sure you want to request the selected pending rows ?",
                            buttons: [
                                {
                                    label: "Yes",
                                    variant: "info",
                                    action: "pending",
                                },
                                {
                                    label: "No",
                                    class: "ml-2",
                                },
                            ],
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-reply text-orange",
                        position: "toolbar",
                        action: "publishconfirm",
                        label: "Live Segments",
                        overlay: {
                            message: "Are you sure you want to publish the selected rows ?",
                            buttons: [
                                {
                                    label: "Yes",
                                    variant: "danger",
                                    action: "publish",
                                },
                                {
                                    label: "No",
                                    class: "ml-2",
                                },
                            ],
                        },
                    },
                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },

                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        // class: "text-left",
                    },
                    {
                        key: "equipment",
                        label: "Equipment",
                        sortable: true,
                        // class: "text-left",
                    },
                    {
                        key: "cabin",
                        label: "Cabin",
                        sortable: true,
                        // class: "text-left",
                    },
                    {
                        key: "startcity",
                        label: "Start City",
                        sortable: true,
                        // class: "text-left",
                    },
                    {
                        key: "endcity",
                        label: "End City",
                        sortable: true,
                        // class: "text-left",
                    },
                    {
                        key: "emission",
                        label: "Emission Tonnes CO2 ",
                        sortable: true,
                    },
                    {
                        key: "distance",
                        label: "Distance KM",
                        sortable: true,
                    },
                     {
                        key: "duration",
                        label: "Duration",
                        sortable: true,
                    },
                    {
                        key: "methodology",
                        label: "Methodology",
                        sortable: true,
                    },
                    {
                        key: "source",
                        label: "Source",
                        sortable: true,
                    },
                    {
                        key: "refresh",
                        label: "State",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "type",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "equipment",
                        type: "pill",
                        class: "purple",
                    },
                    {
                        key: "cabin",
                        type: "badge",
                        economy: "success",
                        premium: "orange",
                        business: "info",
                        first: "purple",
                    },
                    {
                        key: "source",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "refresh",
                        type: "badge",
                        Pending: "warning",
                        Ready: "success",
                        formatter: (value, key, item) => {
                            if (value == false) {
                                return "Ready";
                            } else if (value == true) {
                                return "Pending";
                            } else {
                                return "";
                            }
                        },
                    },

                ],
                items: [],
                selected: [],
            },
            message: null,
        };
    },
    async mounted() {
        this.accessdenied();
        await this.carbonsegments_load();
    },

    methods: {
        accessdenied() {
            this.carbonsegments.denied = [];
            if (!this.user.permissions.includes("systems.development")) {
                this.carbonsegments.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("systems.development")) {
                this.carbonsegments.denied.push("publishconfirm");
            }
            if (this.user.permissions.includes("systems.development")) {
                this.options_snapshot.push({ id: "data_finance", label: "data_finance" })
                this.options_snapshot.push({ id: "data_carbon", label: "data_carbon" })
            }
        },
        async carbonsegments_load(offset, limit, page) {

            console.log('carbonsegments_load', offset, limit, page)
            let state = this.carbonsegments;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                snapshot: this.snapshot ? this.snapshot : 'live_finance',
                type: this.type.length > 0 ? this.type.join(",") : null,
                cabin: this.cabin.length > 0 ? this.cabin.join(",") : null,
                source: this.source.length > 0 ? this.source.join(",") : null,
                startcity: this.startcity.length > 0 ? this.startcity.join(",") : null,
                endcity: this.endcity.length > 0 ? this.endcity.join(",") : null,
                equipment: this.equipment.length > 0 ? this.equipment.join(",") : null,
                // startcity: this.startcity,
                // endcity: this.endcity,
                // equipment: this.equipment,
                methodology: this.methodology,
                notes: this.notes,
                emission: this.emission,
                distance: this.distance,
                updated_by: this.updated_by,
                updated_at: this.updated_at.startDate ? [this.updated_at.startDate, this.updated_at.endDate] : null
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query carbonsegments(
                            $limit: Int
                            $offset: Int
                            $snapshot: String
                            $type: String
                            $startcity: String
                            $endcity: String
                            $equipment: String
                            $cabin: String
                            $source: String   
                            $methodology: String   
                            $emission: String
                            $distance: String
                            $notes: String
                            $updated_by: String
                            $updated_at: [String]
                        ) {
                            carbonsegments(
                            limit: $limit
                            offset: $offset
                            snapshot: $snapshot
                            type: $type
                            startcity: $startcity
                            endcity: $endcity
                            equipment: $equipment
                            cabin: $cabin
                            methodology: $methodology  
                            emission: $emission
                            distance: $distance
                            source: $source  
                            notes: $notes
                            updated_by: $updated_by,
                            updated_at: $updated_at,                       
                            ) {
                            id
                            type
                            equipment
                            cabin
                            startcity
                            endcity
                            distance
                            duration
                            adjusted
                            emission
                            source
                            message
                            location
                            nights
                            rooms
                            methodology
                            refresh
                            notes
                            updated_by
                            updated_at
                            rows
                            }
                        }
                        `,
                    variables,
                });

                // USE LOCAL VARIABLE
                if (limit == 0) {
                    state.selected = response.data.carbonsegments
                } else {
                    state.items = []
                    state.items = response.data.carbonsegments;
                }



            } catch (error) {
                console.log(error);
            }
            this.message = null
            state.busy = false;
        },
        async carbonsegments_click(a, ss) {

            let state = this.carbonsegments;

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    break;
                case "go":
                    this.component = null;
                    this.carbonsegments_load(0);
                    break;
                case "add":
                case "edit":
                    this.component = "CarbonSegmentEdit";
                    break;
                case "pastespecial":
                    state.pastespecial = !state.pastespecial
                    break;

                case "import":
                    this.component = "CarbonSegmentImport";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

                case "cancel":
                    this.cancelit(ss);
                    break;

                case "publish":
                    this.publishit(ss, a);
                    break;

                case "pending":
                    this.publishit(ss, a);
                    break;

                // case "cancelconfirm":
                // case "pendingconfirm":
                //     this.emission = '<api pending>'
                //     this.carbonsegments_load(0);
                //     break;
            }
        },
        async carbonsegments_select(ss, tools) {
            this.message = null

            let state = this.carbonsegments;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "import", "export", "pastespecial", "cancelconfirm", "pendingconfirm", "publishconfirm","clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation carbonsegments_save($rows: [Carbonsegment_input]) {
                            carbonsegments_save(rows: $rows) {
                            id
                            type
                            equipment
                            cabin
                            startcity
                            endcity
                            distance
                            duration
                            adjusted
                            emission
                            source
                            location
                            nights
                            rooms
                            methodology
                            message
                            refresh
                            notes
                            }
                        }
                        `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
                snapshot: this.snapshot ? this.snapshot : 'live_finance'
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation carbonsegments_delete($rows: [Carbonsegment_input],$snapshot: String) {
                carbonsegments_delete(rows: $rows, snapshot: $snapshot) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.carbonsegments_load();
        },
        async cancelit(ss) {

            let state = this.carbonsegments;
            state.busy = true;

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
                snapshot: this.snapshot ? this.snapshot : 'live_finance'
            };

            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation carbonsegments_cancel($rows: [Carbonsegment_input],$snapshot: String) {
                            carbonsegments_cancel(rows: $rows, snapshot: $snapshot)
                        }
                        `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false;

            await this.carbonsegments_load();
        },
        async publishit(ss, a) {
            console.log('publishit', ss, a)

            if (ss.length == 0) {
                this.message = "Selection is empty, nothing to publsh."
                return
            }

            let copyto = this.snapshot
            switch (a) {
                case "pending":
                    copyto = "data_carbon"
                    break;
                case "publish":
                    copyto = "live_finance"
                    break;
            }

            if (this.snapshot == copyto) {
                this.message = "Not a valid source."
                return
            }

            let state = this.carbonsegments;
            state.busy = true;

            let variables = { rows: this.cleanit(ss), snapshot: copyto };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation carbonsegments_save($rows: [Carbonsegment_input], $snapshot: String) {
                            carbonsegments_save(rows: $rows, snapshot: $snapshot) {
                            id
                            type
                            equipment
                            cabin
                            startcity
                            endcity
                            distance
                            duration
                            adjusted
                            emission
                            source
                            location
                            nights
                            rooms
                            methodology
                            message
                            refresh
                            notes
                            }
                        }
                        `,
                    variables,
                });

                // this.message = "Uploaded these rows:\n" + JSON.stringify(variables) 
                this.message = "Published " + response.data.carbonsegments_save.length + " row(s)"

                // this.message = "<span class='text-primary'>Uploaded it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            state.busy = false;

        }
    },
};
</script>
    
<style></style>